
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UploadedFileUpdate } from 'ah-requests';

/**
 * Emits:
 * - cancel (no payload): when user cancels on going file upload
 */
@Component
export default class FileUploadStatus extends Vue {
  @Prop({ required: true }) file!: File;

  @Prop({ default: null }) uploadStatus!: UploadedFileUpdate<any> | null;

  get completedBarWidth() {
    return {
      width: `${this.uploadPercentage}%`,
    };
  }

  get startedUpload() {
    return this.uploadStatus?.finished === false;
  }

  get finishedUpload() {
    return this.uploadStatus?.finished;
  }

  get fileSize() {
    if (this.uploadStatus) {
      if (this.uploadStatus.bytesTotal < 100000) {
        return (this.uploadStatus.bytesTotal / 1000).toFixed(2) + ' KB';
      }
      return (this.uploadStatus.bytesTotal / 1000000).toFixed(2) + ' MB';
    }
    return 'Unknown';
  }

  get uploadPercentage() {
    if (this.uploadStatus) {
      if (this.uploadStatus.bytesLoaded === 0 || this.uploadStatus.bytesTotal === Infinity) {
        return 0;
      } else {
        return (this.uploadStatus.bytesLoaded / this.uploadStatus.bytesTotal) * 100;
      }
    }
    return 0;
  }

  get uploadPercentageText() {
    return Math.floor(this.uploadPercentage).toString();
  }
}
